import { useEffect, useState } from "react";
import { Unlink } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/intl";
import { Button } from "@/components/ui/button";
import { errMsg } from "./kpiFormat";

const name = (id, n) => (n ? `${n} (${id})` : id);

/** Manual "same person" links made from the KPI lead lists, with undo. */
export const ClientLinksPanel = () => {
  const [rows, setRows] = useState(null);
  const load = () => api.get("/kpi/client-links").then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);
  const unlink = async (r) => {
    if (!window.confirm(`Count ${r.from_name || r.from_id} as a separate person again?`)) return;
    try {
      await api.delete(`/kpi/client-links/${encodeURIComponent(r.from_id)}`);
      toast.success("Link removed", { description: "Refresh the affected week's draft to recount." });
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <section className="space-y-3" data-testid="kpi-client-links">
      <div>
        <h2 className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500">Same-person links</h2>
        <p className="mt-1 text-xs text-zinc-500">Leads you've marked as the same person from a KPI lead list. Enquiries with the same
          mobile number and a similar name are joined automatically and don't appear here.</p>
      </div>
      {!rows ? <div className="h-12 animate-pulse rounded bg-zinc-100" /> : !rows.length ? (
        <p className="text-sm text-zinc-500" data-testid="kpi-client-links-empty">No links yet.</p>
      ) : (
        <table className="w-full max-w-4xl text-sm">
          <tbody>
            {rows.map((r) => (
              <tr key={r.from_id} className="border-t border-zinc-100" data-testid={`kpi-client-link-${r.from_id}`}>
                <td className="py-2 pr-3 text-zinc-800">{name(r.from_id, r.from_name)}</td>
                <td className="py-2 pr-3 text-zinc-400">is the same person as</td>
                <td className="py-2 pr-3 text-zinc-800">{name(r.to_id, r.to_name)}</td>
                <td className="py-2 pr-3 text-xs text-zinc-500">{r.by} · {fmtDateTime(r.at)}</td>
                <td className="py-2 text-right">
                  <Button size="sm" variant="ghost" onClick={() => unlink(r)} data-testid={`kpi-client-unlink-${r.from_id}`}>
                    <Unlink className="mr-1 h-3.5 w-3.5" />Unlink
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
};
